// extracted by mini-css-extract-plugin
export default {"tabelaDanychKontener":"Row_tabelaDanychKontener__c5ebH","tabelaKontener":"Row_tabelaKontener__pJ9Iz","glownaTabela":"Row_glownaTabela__ayvEH"};